import React from "react"
import { Container, StyledImg } from "./RelatedProviders.styles"
import { Card } from "../Card/Card"
import { Link } from "gatsby"
import { Icon } from "../Icon/Icon"

const RelatedProviders = providers => {
  var data = providers.providers[0]
  // The pages on the wordpress site to return providers as an array
  if (!Array.isArray(providers.providers[0]))
    data = Array.from(providers.providers)

  const providerButtons = data.map(provider => (
    <Card
      width="100%"
      justify="space-between"
      key={data.slug}
      content={
        <>
          <div className="leftWrap">
            <div className="left">
              <div className="leftInner">
                <Icon className="icon" category="Providers" />
                <p className="secondaryLink">Providers</p>
              </div>

              <Link to={`/Providers/${provider.slug}`}>
                <p className="headline">
                  {provider.acf_providers.providerName}{" "}
                  <Icon category="Chevron Right" />
                </p>
              </Link>

              <br />
              <p className="paragraph">{provider.acf_providers.description}</p>
            </div>
          </div>
          <StyledImg
            src={provider.acf_providers.image.mediaItemUrl}
            alt={provider.acf_providers.image.altText}
          ></StyledImg>
        </>
      }
    ></Card>
  ))

  return (
    <>
      <Container>{providerButtons}</Container>
    </>
  )
}

export default RelatedProviders
